import { Box, Button, Card, CardContent, Container, Divider, Grid, Link, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import getStockTabs from '../../lib/stock/_getStockTabsData';
import getPageMetaTags from '../../lib/meta/_getMetaTags';
import { dataConstants } from '../../src/constants';

const ContactUs = () => {
  const { asPath } = useRouter();

  return (
    <Container maxWidth="md" sx={{ my: 15, textAlign: 'center' }}>
      <Box component="div" sx={{ my: 5 }}>
        <Typography variant="h1" sx={{ mb: 5, textAlign: 'center', fontSize: '1.5rem', fontWeight: 500 }}>Contact Us</Typography>
      </Box>
      <Container maxWidth="sm" sx={{ mb: 10, textAlign: 'center' }}>
        <Typography variant="p">We love to hear from our users.<br /><br /> If you have any feedback, query, or want to discuss opportunities etc., then you can reach us through any of the following channels.</Typography>
      </Container>
      <Box component="div" sx={{
        flexDirection: { xs: 'column', sm: 'column', md: 'row' },
        textAlign: 'center', display: 'flex', justifyContent: 'space-between', mb: 4, '& a:hover': { textDecoration: 'underline', },
        '& a': { textDecoration: 'none', ml: 1, mr: .3, color: '#184c86', fontWeight: 500, fontSize: '.875rem' },
      }}>
        <Card sx={{ my: 1.2, display: 'flex', minWidth: '270px', justifyContent: 'center', boxShadow: '0 0.5px 1px rgba(132,135,154,.2), 0 2px 3px rgba(132,135,154,.1)', background: '#fbfbfc', border: '1px solid #eae9ee', borderRadius: '5px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flex: '1 0 auto' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <EmailRoundedIcon fontSize="large" sx={{ fontSize: '1.7rem', mr: 1, color: '#D44638' }} />
                {/* <Typography component="div" variant="h6" sx={{ fontSize: '1rem' }}>
                  Email
                </Typography> */}
              </Box>
              <Typography variant="subtitle1" component="div" sx={{ fontSize: '.875rem', my: 1 }}>
                Our team is here to help
              </Typography>
            </CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'center', pl: 1, pb: 1 }}>
              <a href="mailto:contact@grufity.com?subject=From Contact Page">contact@grufity.com</a>
            </Box>
          </Box>
        </Card>
        <Card sx={{ my: 1.2, display: 'flex', minWidth: '270px', justifyContent: 'center', boxShadow: '0 0.5px 1px rgba(132,135,154,.2), 0 2px 3px rgba(132,135,154,.1)', background: '#fbfbfc', border: '1px solid #eae9ee', borderRadius: '5px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flex: '1 0 auto' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <LinkedInIcon fontSize="large" sx={{ fontSize: '1.7rem', mr: 1, color: '#0077b5' }} />
                {/* <Typography component="div" variant="h6" sx={{ fontSize: '1rem' }}>
                  Linkedin
                </Typography> */}
              </Box>
              <Typography variant="subtitle1" component="div" sx={{ fontSize: '.875rem', my: 1 }}>
                Get in touch with us
              </Typography>
            </CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'center', pl: 1, pb: 1 }}>
              <a href="https://www.linkedin.com/company/grufitycom">grufitycom</a>
            </Box>
          </Box>
        </Card>
        <Card sx={{ my: 1.2, display: 'flex', minWidth: '270px', justifyContent: 'center', boxShadow: '0 0.5px 1px rgba(132,135,154,.2), 0 2px 3px rgba(132,135,154,.1)', background: '#fbfbfc', border: '1px solid #eae9ee', borderRadius: '5px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <CardContent sx={{ flex: '1 0 auto' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <TwitterIcon fontSize="large" sx={{ fontSize: '1.7rem', mr: 1, color: '#00acee' }} />
                {/* <Typography component="div" variant="h6" sx={{ fontSize: '1rem' }}>
                  Twitter
                </Typography> */}
              </Box>
              <Typography variant="subtitle1" component="div" sx={{ fontSize: '.875rem', my: 1 }}>
                You can DM us at any of <br />the following Twitter accounts
              </Typography>
            </CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'center', pl: 1, pb: 1 }}>
              <a href="https://twitter.com/grufity">@grufity</a>,
              <a href="https://twitter.com/grufityreports">@grufityreports</a>
            </Box>
          </Box>
        </Card>
      </Box>
      <Container maxWidth="sm" sx={{ mt: 12, textAlign: 'center', fontSize: '.87rem', '& a': { color: '#174ea6' }, color: '#444' }}>
        <Typography variant="p" sx={{ lineHeight: 1.75 }}>
          For reporting issues or bugs, please visit our <Link href="/report-issue" underline="hover">Report an Issue page</Link>.<br /> This dedicated page allows you to submit your concerns directly to our team for better tracking and faster responses. We will address and respond to your issues there.
        </Typography>
      </Container>
    </Container>
  )
}

export async function getStaticProps({ tabCode = "ABOUT", ticker = "" }) {

  const meta_tags = (await getPageMetaTags('/contact', false)) || {}
  const { getMetaTags } = meta_tags || {}
  return {
    props: {
      meta_tags: getMetaTags?.tags || null
    },
    revalidate: dataConstants.REVALIDATE_IN.DEFAULT_HOURS,
    // notFound: !ticker ? true : false,
  }
}

export default ContactUs
